import React from 'react';
import withAuthorization from '../../hoc/withAuthorization';
import LargePaper from '../../components/Layout/LargePaper';
import stylesDefault from '../../constants/stylesDefault';
import BookingsLldTabs from '../../components/BookingsLld/BookingsLldTabs';
import LldSitesSelect from '../../components/LldSitesSelect/LldSitesSelect';

const BookingsLldPage = () => {

  return (
    <LargePaper>
      <h1 style={stylesDefault.title}>Réservations longue durée</h1>
      <LldSitesSelect />
      <BookingsLldTabs />
    </LargePaper>
  );
};

const authCondition = authUser => !!authUser;

export default withAuthorization(authCondition)(BookingsLldPage);



// WEBPACK FOOTER //
// ./src/containers/BookingsLld/BookingsLldPage.jsx